/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentImportProvider =
    (typeof DocumentImportProvider)[keyof typeof DocumentImportProvider];

export const DocumentImportProvider = {
    SharePoint: 'SharePoint',
    OneDrive: 'OneDrive',
    GoogleDrive: 'GoogleDrive',
    Dropbox: 'Dropbox',
    LocalArchive: 'LocalArchive',
    Procore: 'Procore',
} as const;
